<template>
  <div class="left-aligned-form">
    <div class="title">
      <h3>退回手机详情</h3>
    </div>
    <el-form ref="phoneForm" :model="phoneForm" label-width="125px">
      <el-form-item label="手机品牌:" v-show="this.phoneForm.phonBrand">
        <el-input v-model="phoneForm.phonBrand" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="型号:" v-show="this.phoneForm.phoneName">
        <el-input v-model="phoneForm.phoneName" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="颜色:" v-show="this.phoneForm.phoneColor">
        <el-input
          v-model="phoneForm.phoneColor"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="内存:" v-show="this.phoneForm.phoneMemory" >
        <el-input
          v-model="phoneForm.phoneMemory"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="序列号:" v-show="this.phoneForm.SNName">
        <el-input v-model="phoneForm.SNName" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="IMEI:" v-show="this.phoneForm.IMEIName">
        <el-input v-model="phoneForm.IMEIName" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="IMEI2:" v-show="this.phoneForm.IMEI2Name">
        <el-input v-model="phoneForm.IMEI2Name" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="正面图:" v-show="this.phoneForm.screenURL">
        <el-image
          :preview-src-list="[phoneForm.screenURL]"
          style="width: 160px; height: 200px; cursor: pointer"
          :src="phoneForm.screenURL"
        >
        </el-image>
      </el-form-item>
      <el-form-item label="正面图备注:" v-show="this.phoneForm.screenText">
        <el-input
          v-model="phoneForm.screenText"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="背板图:" v-show="this.phoneForm.bankURL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :src="phoneForm.bankURL"
          :preview-src-list="[phoneForm.bankURL]"
        ></el-image>
      </el-form-item>
      <el-form-item label="背板图备注:" v-show="this.phoneForm.bankText">
        <el-input v-model="phoneForm.bankText" style="width: 220px" 
        :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="左侧图:" v-show="this.phoneForm.leftURL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.leftURL]"
          :src="phoneForm.leftURL"
        ></el-image>
      </el-form-item>
      <el-form-item label="左侧图备注:" v-show="this.phoneForm.leftText">
        <el-input v-model="phoneForm.leftText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="右侧图:" v-show="this.phoneForm.rightURL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.rightURL]"
          :src="phoneForm.rightURL"
        ></el-image>
      </el-form-item>
      <el-form-item label="右侧图备注:" v-show="this.phoneForm.rightText">
        <el-input v-model="phoneForm.rightText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="顶部图:" v-show="this.phoneForm.topURL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.topURL]"
          :src="phoneForm.topURL"
        ></el-image>
      </el-form-item>
      <el-form-item label="顶部图备注:" v-show="this.phoneForm.topText">
        <el-input v-model="phoneForm.topText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="底部图:" v-show="this.phoneForm.bottomURL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.bottomURL]"
          :src="phoneForm.bottomURL"
        ></el-image>
      </el-form-item>
      <el-form-item label="底部图备注:" v-show="this.phoneForm.bottomText">
        <el-input
          v-model="phoneForm.bottomText"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="自定义图片1:" v-show="this.phoneForm.custom1URL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.custom1URL]"
          :src="phoneForm.custom1URL"
        ></el-image>
      </el-form-item>
      <el-form-item label="自定义图片1备注:" v-show="this.phoneForm.custom1Text">
        <el-input
          v-model="phoneForm.custom1Text"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="自定义图片2:" v-show="this.phoneForm.custom2URL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.custom2URL]"
          :src="phoneForm.custom2URL"
        ></el-image>
      </el-form-item>
      <el-form-item label="自定义图片2备注:" v-show="this.phoneForm.custom2Text">
        <el-input
          v-model="phoneForm.custom2Text"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="自定义图片3:" v-show="this.phoneForm.custom3URL">
        <el-image
          style="width: 160px; height: 200px; cursor: pointer"
          :preview-src-list="[phoneForm.custom3URL]"
          :src="phoneForm.custom3URL"
        ></el-image>
      </el-form-item>
      <el-form-item label="自定义图片3备注:" v-show="this.phoneForm.custom3Text">
        <el-input
          v-model="phoneForm.custom3Text"
          style="width: 220px"
          :disabled="true"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      phoneForm: {},
      // srcList:[]
    };
  },
  created() {
    const queryID = this.$route.params.id;
    console.log(queryID, "queryID");
    this.getReturnDetail(queryID);
  },
  methods: {
    getReturnDetail(id) {
      var that = this;
      // that.srcList = []
      console.log(id, "id");
      axios({
        method: "post",
        url: "openApi/app/6hudrcag2c01/apply/filter",
        data:{
          pageSize: 99999,
          pageNum: 1,
          queries: [
            {
              queId: 182392834,//sn码182392833
              searchKey: id,
            },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
          // 'Cookie' header should not be set in client-side JavaScript due to security reasons
        },
        // If withCredentials is true, server must echo back the exact value of the Origin request header in the Access-Control-Allow-Origin response header
        withCredentials: true,
      })
        .then((res) => {
          console.log(res,'res');
          res.data.result.result.forEach((item) => {
            item.answers.forEach((element) => {
              console.log(element)
                  if (element.queId == 182392829) {
                        that.$set(
                          that.phoneForm,
                          "phonBrand",
                          element.values[0].value
                        );
                  }
                  if (element.queId == 182392830) {
                    that.$set(
                      that.phoneForm,
                      "phoneName",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392831) {
                    that.$set(
                      that.phoneForm,
                      "phoneColor",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392832) {
                    that.$set(
                      that.phoneForm,
                      "phoneMemory",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392833) {
                    that.$set(
                      that.phoneForm,
                      "SNName",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392834) {
                    that.$set(
                      that.phoneForm,
                      "IMEIName",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392835) {
                    that.$set(
                      that.phoneForm,
                      "IMEI2Name",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392836) {
                    that.$set(
                      that.phoneForm,
                      "screenURL",
                      element.values[0].value
                    );
                    // that.srcList.push(element.values[0].value)
                    // console.log(that.srcList,'srcList')
                  }
                  if (element.queId == 182392837) {
                    that.$set(
                      that.phoneForm,
                      "screenText",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392838) {
                    that.$set(
                      that.phoneForm,
                      "bankURL",
                      element.values[0].value
                    );
                    // that.srcList.push(element.values[0].value)
                  }
                  if (element.queId == 182392839) {
                    that.$set(
                      that.phoneForm,
                      "bankText",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392840) {
                    that.$set(
                      that.phoneForm,
                      "leftURL",
                      element.values[0].value
                    );
                    // that.srcList.push(element.values[0].value)
                  }
                  if (element.queId == 182392841) {
                    that.$set(
                      that.phoneForm,
                      "leftText",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392842) {
                    that.$set(
                      that.phoneForm,
                      "rightURL",
                      element.values[0].value
                    );
                    // that.srcList.push(element.values[0].value)
                  }
                  if (element.queId == 182392843) {
                    that.$set(
                      that.phoneForm,
                      "rightText",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392844) {
                    that.$set(
                      that.phoneForm,
                      "topURL",
                      element.values[0].value
                    );
                    // that.srcList.push(element.values[0].value)
                  }
                  if (element.queId == 182392845) {
                    that.$set(
                      that.phoneForm,
                      "topText",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182392846) {
                    that.$set(
                      that.phoneForm,
                      "bottomURL",
                      element.values[0].value
                    );
                    // that.srcList.push(element.values[0].value)
                  }
                  if (element.queId == 182392847) {
                    that.$set(
                      that.phoneForm,
                      "bottomText",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182394628) {
                    that.$set(
                      that.phoneForm,
                      "custom1URL",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182394629) {
                    that.$set(
                      that.phoneForm,
                      "custom1Text",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182394630) {
                    that.$set(
                      that.phoneForm,
                      "custom2URL",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182394631) {
                    that.$set(
                      that.phoneForm,
                      "custom2Text",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182394632) {
                    that.$set(
                      that.phoneForm,
                      "custom3URL",
                      element.values[0].value
                    );
                  }
                  if (element.queId == 182394633) {
                    that.$set(
                      that.phoneForm,
                      "custom3Text",
                      element.values[0].value
                    );
                  }
            })
          })
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.left-aligned-form {
  text-align: left;
  padding: 10px 0px 10px 0px;
}
.title {
  margin: 10px 10px 20px 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/staticQueryPage.vue